import { isEmpty } from 'lodash'
import i18n from 'config/i18n'

export const setValueLanguage = (
  nameTh?: string | null,
  nameEn?: string | null,
): string => {
  let result = '-'

  if (i18n.language === 'th' && nameTh) {
    result = nameTh
  }

  if (i18n.language === 'en' && nameEn) {
    result = nameEn
  }

  return result
}

export const getLabel = (label?: string, isTime?: boolean): string => {
  if (isEmpty(label) || !label) {
    return ''
  }

  if (isTime) {
    return label
  }

  try {
    return i18n.t(label) || label
  } catch (error) {
    return label
  }
}

export const getBoxTitle = (
  title: string | JSX.Element,
): string | undefined | JSX.Element => {
  return typeof title === 'object' ? title : getLabel(title)
}
